export default __webpack_public_path__ + "static/media/blood-test.48459dbe.png";